import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { Github, Twitter, Linkedin } from "lucide-react";
import { APP_URL } from "@/lib/urls";

const PRODUCT = [
  { label: "Features", to: "/features" },
  { label: "For doctors", to: "/doctors" },
  { label: "Solutions", to: "/solutions" },
  { label: "How it works", to: "/how-it-works" },
  { label: "Pricing", to: "/pricing" },
  { label: "Security", to: "/security" },
];

const COMPANY = [
  { label: "About", to: "/about" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
  { label: "Request demo", to: "/request-demo" },
  { label: "Sign in", href: APP_URL },
];

const SOLUTIONS = [
  { label: "Dental Labs", to: "/solutions/dental-labs" },
  { label: "Dental Offices", to: "/solutions/dental-offices" },
  { label: "Multi-Location Access", to: "/solutions/multi-location-access" },
  { label: "Drivers", to: "/solutions/drivers" },
];

const LEGAL = [
  { label: "Privacy", to: "/legal/privacy" },
  { label: "Terms", to: "/legal/terms" },
  { label: "Refund", to: "/legal/refund" },
  { label: "Cancellation", to: "/legal/cancellation" },
  { label: "Billing", to: "/legal/billing" },
  { label: "Acceptable Use", to: "/legal/acceptable-use" },
  { label: "Cookies", to: "/legal/cookies" },
  { label: "Security", to: "/legal/security" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative border-t hairline bg-background overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 pt-14 pb-8">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8 md:gap-6">
          <div className="col-span-2 md:col-span-2 pr-6">
            <Logo size="md" />
            <p className="mt-4 text-[13px] text-muted-foreground max-w-[260px] leading-relaxed">
              The cloud platform for modern dental laboratories and dental offices, from digital prescription to delivery.
            </p>
            {/* <a
              href="mailto:sales@rxn3d.com"
              className="mt-5 inline-flex items-center gap-2 text-[13px] font-medium hover:opacity-80"
            >
              <Mail className="h-3.5 w-3.5 text-brand-plum" />
              sales@rxn3d.com
            </a> */}
            <div className="mt-5 flex items-center gap-1.5">
              {[
                { Icon: Github, label: "GitHub" },
                { Icon: Twitter, label: "Twitter" },
                { Icon: Linkedin, label: "LinkedIn" },
              ].map(({ Icon, label }, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label={label}
                  data-testid={`footer-social-${i}`}
                  className="h-8 w-8 rounded-full hairline inline-flex items-center justify-center hover:bg-secondary transition-colors"
                >
                  <Icon className="h-3.5 w-3.5" />
                </a>
              ))}
            </div>
          </div>

          <FooterCol title="Product" links={PRODUCT} />
          <FooterCol title="Solutions" links={SOLUTIONS} />
          <FooterCol title="Company" links={COMPANY} />
          <FooterCol title="Legal" links={LEGAL} />
        </div>

        <div className="mt-12 pt-6 border-t hairline flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-[12px] text-muted-foreground">
          <div>© {new Date().getFullYear()} Rxn3D LLC. All rights reserved.</div>
          <div className="flex items-center gap-4">
            <span>Made for modern dental operations.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <div className="text-[11px] tracking-[0.22em] uppercase font-semibold text-muted-foreground mb-3">
        {title}
      </div>
      <ul className="space-y-2">
        {links.map((l) => (
          <li key={l.to || l.href}>
            {l.href ? (
              <a
                href={l.href}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-[13px] text-muted-foreground hover:text-foreground transition-colors"
              >
                {l.label}
              </a>
            ) : (
              <Link
                to={l.to}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-[13px] text-muted-foreground hover:text-foreground transition-colors"
              >
                {l.label}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
